import Vue from 'vue'

export const error = {
  namespaced: true,
  state: {
    data: {
      status: null,
      code: null,
      message: '',
    }
  },
  mutations: {
    errorSet(state, payload) {
      Vue.set(state.data, 'status', payload.status)
      Vue.set(state.data, 'code', payload.code)
      Vue.set(state.data, 'message', payload.message)
    },
    errorReset(state) {
      Vue.set(state.data, 'status', null)
      Vue.set(state.data, 'code', null)
      Vue.set(state.data, 'message', '')
    },
  },
}
